import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_leave.svg';
import Icon, { IconProps } from './icon';

const IconLeave = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconLeave;
